/* eslint-disable max-len */
/**
 * @file 任务路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';
import { isOa } from '@/utils';

export default [
  {
    label: '策略',
    key: 'task',
    perm: (loginStatus: any) => !isOa() && !loginStatus.onlyTechAgency,
    data: [
      {
        label: '梧桐策略管理系统',
        key: 'task_manage',
        iconClassName: 'icon-nav-strategy',
        data: [
          {
            id: 'taskCenter_team',
            href: '/agency/task-center/team',
            key: 'taskCenter_team',
            label: '团队任务',
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/TaskCenter/team-task'), { fallback: <Loading /> }),
            perm: (loginStatus: Record<string, any>) => loginStatus.dynamicNavAuth?.taskTeamEnable !== false,
            basePage: true,
            singleTabNav: true,
          },
          {
            id: 'taskCenter_personal',
            href: '/agency/task-center/personal',
            key: 'taskCenter_personal',
            label: '个人任务',
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/TaskCenter/personal-task'), { fallback: <Loading /> }),
            basePage: true,
            singleTabNav: true,
          },
          {
            key: 'task-strategy',
            label: '策略管理',
            href: '/agency-task/strategy/list',
            path: '/agency-task/strategy',
            purview: 100000000,
            enableKey: 'is_private_strategy_enable',
            isMicroApp: true,
            basePage: true,
            hideSubNav: true,
            singleTabNav: true,
          },
          {
            key: 'task-task-operation',
            label: '任务组管理',
            href: '/agency-task/task/operation',
            path: '/agency-task/task',
            purview: 100000001,
            enableKey: 'is_private_strategy_enable',
            isMicroApp: true,
            basePage: true,
            hideSubNav: true,
            singleTabNav: true,
          },
          {
            id: 'task-dashboard-employee-finished',
            label: '员工数据',
            href: '/agency/task-center/employee/finished',
            hide: true,
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/dashboard/employee/finish'), { fallback: <Loading /> }),
            basePage: true,
            hideTabNav: true,
            hideSubNav: true,
          },
          {
            id: 'task-dashboard-employee-ongoing',
            label: '员工数据',
            href: '/agency/task-center/employee/ongoing',
            hide: true,
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/dashboard/employee/on-going'), { fallback: <Loading /> }),
            basePage: true,
            hideTabNav: true,
            hideSubNav: true,
          },
          {
            id: 'task-dashboard-strategy-finished',
            label: '策略详情',
            href: '/agency/task-center/strategy/finished',
            hide: true,
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/dashboard/strategy/finish'), { fallback: <Loading /> }),
            basePage: true,
            hideTabNav: true,
            hideSubNav: true,
          },
          {
            id: 'task-dashboard-strategy-ongoing',
            label: '策略详情',
            href: '/agency/task-center/strategy/ongoing',
            hide: true,
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/dashboard/strategy/on-going'), { fallback: <Loading /> }),
            basePage: true,
            hideTabNav: true,
            hideSubNav: true,
          },
          {
            id: 'task-dashboard-task-finished',
            label: '任务详情',
            href: '/agency/task-center/task/finished',
            hide: true,
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/dashboard/task/finish'), { fallback: <Loading /> }),
            basePage: true,
            hideTabNav: true,
            hideSubNav: true,
          },
          {
            id: 'task-dashboard-task-ongoing',
            label: '任务详情',
            href: '/agency/task-center/task/ongoing',
            hide: true,
            component: loadable(() => import(/* webpackChunkName: 'task' */ /* webpackMode: 'lazy' */ '@/pages/agency/task/dashboard/task/on-going'), { fallback: <Loading /> }),
            basePage: true,
            hideTabNav: true,
            hideSubNav: true,
          },
        ],
      },
    ],
  },
];
